export default {
  sort: 1,
  path: '/newOrders',
  name: 'newOrders',
  component: () => import('@/views/new/order/order.vue')
}



// WEBPACK FOOTER //
// ./src/router/modules/newOrder.js